import type { WellDetailsState, WellDetailsStore } from "./wellDetailsStore";

// ── Scalar selectors ─────────────────────────────────────────────────────────
export const selectCurrentGroup = (s: WellDetailsStore) => s.currentGroup;

// ── Action selectors ─────────────────────────────────────────────────────────
export const selectSetActiveGroup = (s: WellDetailsStore) => s.setActiveGroup;
export const selectReset = (s: WellDetailsStore) => s.reset;

// ── Compound selectors ───────────────────────────────────────────────────────

/**
 * Full client-selection state (actions stripped). Returns a new object on
 * every call — consumers MUST use shallow equality:
 *
 *   import { useShallow } from "zustand/react/shallow";
 *   const state = useWellDetailsStore(useShallow(selectWellDetailsState));
 */
export const selectWellDetailsState = (s: WellDetailsStore): WellDetailsState => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { setActiveGroup, reset, ...state } = s;
  return state;
};
